/* tslint:disable */
/* eslint-disable */
/**
 * Flawatch Backend
 * Flawatch ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamFeatures
 */
export interface TeamFeatures {
    /**
     * Access to Domains feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasDomainsFeature?: boolean;
    /**
     * Access to Subdomains feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasSubdomainsFeature?: boolean;
    /**
     * Access to IP Addresses feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasIpAddressesFeature?: boolean;
    /**
     * Access to Ports feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasPortsFeature?: boolean;
    /**
     * Access to Web Applications feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasWebApplicationsFeature?: boolean;
    /**
     * Access to Security Findings feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasSecurityFindingsFeature?: boolean;
    /**
     * Access to Security Center feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasSecurityCenterFeature?: boolean;
    /**
     * Access to Domain Monitoring feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasDomainMonitoringFeature?: boolean;
    /**
     * Access to Infringements feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasInfringementsFeature?: boolean;
    /**
     * Access to VIP Profiles feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasVipProfilesFeature?: boolean;
    /**
     * Access to Data Overview feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasDataOverviewFeature?: boolean;
    /**
     * Access to Data Search feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasDataSearchFeature?: boolean;
    /**
     * Access to Public Leaks feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasPublicLeaksFeature?: boolean;
    /**
     * Access to Stealer Leaks feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasStealerLeaksFeature?: boolean;
    /**
     * Access to Data Leaks feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasDataLeaksFeature?: boolean;
    /**
     * Access to NACSA Checklist feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasNacsaChecklistFeature?: boolean;
    /**
     * Access to Reports feature
     * @type {boolean}
     * @memberof TeamFeatures
     */
    hasReportsFeature?: boolean;
}

/**
 * Check if a given object implements the TeamFeatures interface.
 */
export function instanceOfTeamFeatures(value: object): value is TeamFeatures {
    return true;
}

export function TeamFeaturesFromJSON(json: any): TeamFeatures {
    return TeamFeaturesFromJSONTyped(json, false);
}

export function TeamFeaturesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamFeatures {
    if (json == null) {
        return json;
    }
    return {
        
        'hasDomainsFeature': json['has_domains_feature'] == null ? undefined : json['has_domains_feature'],
        'hasSubdomainsFeature': json['has_subdomains_feature'] == null ? undefined : json['has_subdomains_feature'],
        'hasIpAddressesFeature': json['has_ip_addresses_feature'] == null ? undefined : json['has_ip_addresses_feature'],
        'hasPortsFeature': json['has_ports_feature'] == null ? undefined : json['has_ports_feature'],
        'hasWebApplicationsFeature': json['has_web_applications_feature'] == null ? undefined : json['has_web_applications_feature'],
        'hasSecurityFindingsFeature': json['has_security_findings_feature'] == null ? undefined : json['has_security_findings_feature'],
        'hasSecurityCenterFeature': json['has_security_center_feature'] == null ? undefined : json['has_security_center_feature'],
        'hasDomainMonitoringFeature': json['has_domain_monitoring_feature'] == null ? undefined : json['has_domain_monitoring_feature'],
        'hasInfringementsFeature': json['has_infringements_feature'] == null ? undefined : json['has_infringements_feature'],
        'hasVipProfilesFeature': json['has_vip_profiles_feature'] == null ? undefined : json['has_vip_profiles_feature'],
        'hasDataOverviewFeature': json['has_data_overview_feature'] == null ? undefined : json['has_data_overview_feature'],
        'hasDataSearchFeature': json['has_data_search_feature'] == null ? undefined : json['has_data_search_feature'],
        'hasPublicLeaksFeature': json['has_public_leaks_feature'] == null ? undefined : json['has_public_leaks_feature'],
        'hasStealerLeaksFeature': json['has_stealer_leaks_feature'] == null ? undefined : json['has_stealer_leaks_feature'],
        'hasDataLeaksFeature': json['has_data_leaks_feature'] == null ? undefined : json['has_data_leaks_feature'],
        'hasNacsaChecklistFeature': json['has_nacsa_checklist_feature'] == null ? undefined : json['has_nacsa_checklist_feature'],
        'hasReportsFeature': json['has_reports_feature'] == null ? undefined : json['has_reports_feature'],
    };
}

  export function TeamFeaturesToJSON(json: any): TeamFeatures {
      return TeamFeaturesToJSONTyped(json, false);
  }

  export function TeamFeaturesToJSONTyped(value?: TeamFeatures | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'has_domains_feature': value['hasDomainsFeature'],
        'has_subdomains_feature': value['hasSubdomainsFeature'],
        'has_ip_addresses_feature': value['hasIpAddressesFeature'],
        'has_ports_feature': value['hasPortsFeature'],
        'has_web_applications_feature': value['hasWebApplicationsFeature'],
        'has_security_findings_feature': value['hasSecurityFindingsFeature'],
        'has_security_center_feature': value['hasSecurityCenterFeature'],
        'has_domain_monitoring_feature': value['hasDomainMonitoringFeature'],
        'has_infringements_feature': value['hasInfringementsFeature'],
        'has_vip_profiles_feature': value['hasVipProfilesFeature'],
        'has_data_overview_feature': value['hasDataOverviewFeature'],
        'has_data_search_feature': value['hasDataSearchFeature'],
        'has_public_leaks_feature': value['hasPublicLeaksFeature'],
        'has_stealer_leaks_feature': value['hasStealerLeaksFeature'],
        'has_data_leaks_feature': value['hasDataLeaksFeature'],
        'has_nacsa_checklist_feature': value['hasNacsaChecklistFeature'],
        'has_reports_feature': value['hasReportsFeature'],
    };
}

